// Полетата на плащането — дата (не по-късна от днес), начин (В брой / Банков
// превод / Карта) и основание. Общи за модала „Плащане" и за „Приключи без
// фактура" с отметка „и я отбележи като платена".
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useInventoryShell } from "../../components/shell/InventoryShellContext";
import { SegmentedCounts } from "../../components/list/ListBits";
import { PAYMENT_METHODS } from "../../delivery/components/deliveryMeta";
import { PAYMENT_LABEL_CLASS, type PaymentFieldsValue } from "./paymentFieldsModel";

export const PaymentFields = ({
  value,
  onChange,
  autoFocus = false,
}: {
  value: PaymentFieldsValue;
  onChange: (value: PaymentFieldsValue) => void;
  autoFocus?: boolean;
}) => {
  const { t } = useTranslation();
  const { isNarrow } = useInventoryShell();
  return (
    <>
      <label className="flex flex-col gap-1.5">
        <span className={PAYMENT_LABEL_CLASS}>{t("inventoryPage.payDate")}</span>
        <DatePicker
          autoFocus={autoFocus}
          value={value.paidAt}
          onChange={(paidAt) => paidAt && onChange({ ...value, paidAt })}
          format="DD.MM.YYYY"
          allowClear={false}
          disabledDate={(day) => day.isAfter(dayjs(), "day")}
          className="w-full"
        />
      </label>
      <div className="flex flex-col gap-1.5">
        <span className={PAYMENT_LABEL_CLASS}>{t("inventoryPage.payMethod")}</span>
        <SegmentedCounts
          fill
          value={value.method}
          onChange={(method) => onChange({ ...value, method })}
          options={PAYMENT_METHODS.map((key) => ({
            key,
            label: t(`inventoryPage.payMethod_${key}`),
          }))}
        />
      </div>
      <label className="flex flex-col gap-1.5">
        <span className={PAYMENT_LABEL_CLASS}>{t("inventoryPage.payReference")}</span>
        <input
          value={value.reference}
          onChange={(event) => onChange({ ...value, reference: event.target.value })}
          placeholder={t("inventoryPage.optional")}
          className={`rounded-lg border border-shade-3 bg-surface px-[11px] py-[9px] text-ink outline-none focus:border-brand ${
            isNarrow ? "text-base" : "text-sm"
          }`}
        />
      </label>
    </>
  );
};

export default PaymentFields;
